import { useFormContext } from 'react-hook-form';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from './form';
import { cn } from '../lib/utils';
import { FormControlProps } from '../lib/type';
import { Input } from './input';
import { cva, VariantProps } from 'class-variance-authority';
export const textFieldVariants = cva("input", {
  variants: {
    variant: {
      default: "space-y-4",
      outlined: "input--outlined",
      filled: "input--filled",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const TextField = ({
  name,
  label,
  className,
  variant,
  description,
  propsLabel,
  ...props
}: FormControlProps &
  React.ComponentProps<"input"> &
  VariantProps<typeof textFieldVariants>) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <div className={textFieldVariants({ variant })}>
            {label && (
              <FormLabel htmlFor={name} {...propsLabel}>
                {label}
              </FormLabel>
            )}
            <FormControl>
              <Input
                {...props}
                {...field}
                className={cn("h-12 bg-white", label && "px-3 py-3")}
              />
            </FormControl>
          </div>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
